import { render, staticRenderFns } from "./SubCategoryComponent.vue?vue&type=template&id=5ccae0ba&"
import script from "./SubCategoryComponent.vue?vue&type=script&lang=ts&"
export * from "./SubCategoryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports